import { vuexBase } from '@/store/compositionV2/base'

const createState = () => ({
  ...vuexBase.createState()
})

const createGetters = () => ({
  ...vuexBase.createGetters(),
  getCurrentItemTitle: state => {
    const name = state.currentItem?.name
    if (!name) return ''

    if (state.currentItem?.project_cipher) {
      return state.currentItem.project_cipher + ' ' + name
    }

    return name
  }
})

const createMutations = () => ({
  ...vuexBase.createMutations(),

  // reset store
  RESET_STORE: (state) => {
    state.allItemsChecked = false
    state.list = []
    state.currentItem = {}
    state.filter.query = {}
    state.sort = {
      name: 'id',
      descending: true
    }
    state.pagination.currentPage = 1
  }
})

const createActions = () => ({
  ...vuexBase.createActions()
})

export const vuexPto = {
  createState,
  createGetters,
  createMutations,
  createActions
}
